module.exports = __webpack_public_path__ + "images/volkswagenleasing_smalld2210ce9db3023929a40357af5c0d8c4.png";